<template>
    <div class="content">
        <h4>免责声明</h4>
        <br/>
        <h4>
            一、服务内容声明
        </h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            本网址导航网站致力于为用户提供全面、准确、及时的网址资源。但由于互联网信息的复杂性和多变性，我们无法保证所有链接的时效性和准确性。因此，用户在使用本网站时，需自行判断链接内容的真实性、合法性和安全性。
        </p>
        <br/>
        <h4>
            二、版权声明
        </h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            本网站尊重并保护所有版权人的合法权益。对于网站内出现的链接内容，如涉及版权问题，请版权人及时与我们联系，我们将尽快处理并删除侵权内容。同时，用户在使用本网站时，也需遵守版权法律法规，不得侵犯他人版权。
        </p>
        <br/>
        <h4>
            三、免责范围
        </h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            1.用户在使用本网址导航网站时，应自行判断链接网站的合法性、真实性及有效性。本网站对任何因使用链接网站而可能产生的损失或损害不承担任何责任。
        </p>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            2.本网站不保证链接网站的持续可用性，对于因网站维护、升级或其他原因导致的链接失效，本网站不承担任何责任。
        </p>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            3.用户在使用本网站服务时，应遵守国家法律法规和社会公德，不得利用本网站从事任何非法或违反社会公德的活动。对于因用户违反法律法规或社会公德而造成的任何损失或损害，本网站不承担任何责任。
        </p>

    </div>
</template>

<script>
    export default {
        name: 'StatementContent',
    }
</script>
<style scoped>

</style>